<template>
  <div>
    <input id="file" type="file" multiple />
  </div>
</template>
<script>
import Vue from 'vue'

import VueCompositionAPI, {
  defineComponent,
  reactive,
  computed,
  onMounted,
  toRefs,
  ref,
  watch
} from '@vue/composition-api'

Vue.use(VueCompositionAPI)
// import { uploadFile, STORAGE, getDownloadURL } from '../services/storage';
import createFilePond from './filepond'

import Drive from './drive'

const drive = new Drive()

export default defineComponent({
  name: 'ImageUpload',

  props: {
    required: {
      type: Boolean,
      default: true
    },
    user: {
      type: String,
      required: true
    },
    folderId: {
      type: [String, null],
      default: null
    }
  },
  setup(props, context) {
    let pond

    const files = ref([])
    const valid = ref(true)

    const total = ref(0)
    const uploaded = ref(0)
    const uploadErrors = ref(0)

    const data = reactive({
      errorBag: { required: { valid: true, detail: '' } },
      resetForm: false
    })

    const ids = computed(() => files.value.map(e => e.id))

    watch(
      files,
      val => {
        context.emit('update:files', val)
      },
      { immediate: true }
    )
    watch(
      ids,
      val => {
        context.emit('update:ids', val)
      },
      { immediate: true }
    )
    watch(
      valid,
      val => {
        context.emit('input', val)
      },
      { immediate: true }
    )

    /* ----------- Validation -----------  */
    const resetValidation = () => {
      valid.value = true
      Object.keys(data.errorBag).forEach(key => {
        data.errorBag[key].valid = true
      })

      context.emit('input', valid.value)
    }

    const validate = () => {
      resetValidation()

      if (props.required) {
        if (!files.value.length) {
          data.errorBag.required = reactive({
            valid: false,
            detail: 'At least one image is required'
          })
          valid.value = false
        }
      }

      context.emit('input', valid.value)
    }

    const clearFiles = async () => {
      data.resetForm = true
      await pond.removeFiles()
      setTimeout(() => {
        data.resetForm = false
      }, 3000)
      resetValidation()
    }

    const addTotal = () => {
      total.value += 1
      context.emit('update:total', total.value)
    }
    const addUploaded = () => {
      uploaded.value += 1
      context.emit('update:uploaded', uploaded.value)
    }
    const addError = () => {
      uploadErrors.value += 1
      context.emit('update:uploadErrors', uploadErrors.value)
    }

    /* ----------- Upload -----------  */
    // uplaod image to cloud storage
    const onProcessFile = async ({ file }) => {
      const { path, metadata } = await drive.uploadFile({
        file,
        user: props.user
      })
      const url = await drive.getDownloadURL(path)

      const fileInfo = {
        name: `${file.name}`,
        path,
        url,
        metadata,
        size: file.size
      }

      files.value.push(fileInfo)

      context.emit('upload', fileInfo)
      addUploaded()

      // data.errorBag.required.valid = true;
    }
    // remove image

    onMounted(() => {
      pond = createFilePond({
        el: '#file',
        onProcess: onProcessFile,
        onaddfilestart: addTotal,
        onerror: addError
      })
    })

    return {
      validate,
      resetValidation,
      clearFiles,
      files,
      valid,
      total,
      uploaded,
      uploadErrors,
      ...toRefs(data)
    }
  }
})
</script>

<style>
</style>
